import { createSelector } from '@reduxjs/toolkit'

export const getCurrentUser = ({ user }) => user?.data

export const getUserOrganization = createSelector(getCurrentUser, (user) => user?.organization)
